import { useState, useCallback } from 'react'

const STORAGE_KEY = 'sk_bookmarks'
const RESUME_KEY = 'sk_resume'

function getSlideNumber(sectionId) {
  if (!sectionId) return null
  const match = String(sectionId).match(/Slide[_-](\d+)/i)
  return match ? match[1] : null
}

function loadBookmarks() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

function saveBookmarks(bookmarks) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(bookmarks))
}

function loadResume() {
  try {
    const raw = localStorage.getItem(RESUME_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function useBookmarks() {
  const [bookmarks, setBookmarks] = useState(loadBookmarks)
  const [resumePoint, setResumePoint] = useState(loadResume)

  const updateResume = useCallback((section, categoryId) => {
    if (!section || !section.id) return
    const resume = {
      sectionId: section.id,
      categoryId,
      geezPreview: (section._geeztext || '').substring(0, 50),
      slideNumber: getSlideNumber(section.id),
      savedAt: Date.now()
    }
    localStorage.setItem(RESUME_KEY, JSON.stringify(resume))
    setResumePoint(resume)
  }, [])

  const isBookmarked = useCallback((sectionId) => {
    return bookmarks.some(bm => bm.sectionId === sectionId)
  }, [bookmarks])

  const toggleBookmark = useCallback((section, categoryId) => {
    setBookmarks(prev => {
      const exists = prev.some(bm => bm.sectionId === section.id)
      let next
      if (exists) {
        next = prev.filter(bm => bm.sectionId !== section.id)
      } else {
        next = [{
          sectionId: section.id,
          categoryId,
          geezPreview: (section._geeztext || '').substring(0, 50),
          englishPreview: (section._englishtext || '').substring(0, 50),
          slideNumber: getSlideNumber(section.id),
          savedAt: Date.now()
        }, ...prev]
      }
      saveBookmarks(next)
      return next
    })
  }, [])

  const removeBookmark = useCallback((sectionId) => {
    setBookmarks(prev => {
      const next = prev.filter(bm => bm.sectionId !== sectionId)
      saveBookmarks(next)
      return next
    })
  }, [])

  return { bookmarks, isBookmarked, toggleBookmark, removeBookmark, resumePoint, updateResume }
}
